import React from 'react';

const Badge = ({ children, className = '' }) => {
  return (
    <span className={`
      font-display text-[10px] sm:text-xs uppercase tracking-wider 
      bg-dc-teal-deep/10 text-dc-teal-deep 
      py-1.5 px-4 rounded-full font-semibold
      ${className}
    `}>
      {children}
    </span>
  );
};

export default Badge;